const NotFoundPage = () => {
  document.title = "404 - Page Not Found";
  return <>Are you lost? This page doesn&#39;t exist.</>;
};

export default NotFoundPage;
